export default __webpack_public_path__ + "static/media/loupe.812d0444.svg";